import * as Handlebars from 'handlebars/runtime'
module.exports = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"display-pane-body table-hack-row\">\n	<div class=\"table-hack-cell\">\n		<div class=\"scroll-container\"></div>\n	</div>\n</div>";
},"useData":true})